import React, { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

interface InfiniteScrollComponentProps {
  children: any;
  dataLength?: number;
  currentPage: number;
  totalPages: number;
  getData: (page: number) => void;
  loadingBlock?: JSX.Element;
  scrollableTarget: string;
  isLast: boolean;
  scrollThreshold?: number;
  dataTestId?: string;
}

const InfiniteScrollComponent: FC<InfiniteScrollComponentProps> = ({
  children,
  dataLength,
  currentPage,
  totalPages,
  getData,
  loadingBlock,
  scrollableTarget,
  isLast,
  scrollThreshold = 0.1,
  dataTestId,
}) => {
  return (
    <div id="infinite_scroll_wrapper" data-test-id={`${dataTestId}-wrapper`}>
      <InfiniteScroll
        dataLength={dataLength || children?.length || 0}
        next={() => {
          getData(currentPage + 1);
        }}
        scrollThreshold={scrollThreshold}
        hasMore={!isLast && currentPage + 1 !== totalPages}
        loader={loadingBlock || <></>}
        endMessage={<></>}
        pullDownToRefreshThreshold={0}
        scrollableTarget={scrollableTarget}
      >
        {children}
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteScrollComponent;
